import config from '../..//services/config';
import BaseDrawingObject from "./baseDrawingObject";


class Line extends BaseDrawingObject {
    constructor(startX, startY, endX, endY, layerNumber, blockName, objNumSeqNum, closedIndicator) {
        super();
        this.startPoint = { x: startX, y: startY };
        this.endPoint = { x: endX, y: endY };
        this.layerNumber = layerNumber;
        this.blockName = blockName;
        this.objNumSeqNum = objNumSeqNum;
        this.closedIndicator = closedIndicator;
        //this.dashEnabled = false
        this.dashEnabled = true;
        this.dashArray = [100, 60];//100, 60
        this.type = 'line';
        if (objNumSeqNum !== undefined) {
            this.objectNumber = parseInt(objNumSeqNum.substring(0, objNumSeqNum.lastIndexOf("_"))),
            this.sequenceNumber = parseInt(objNumSeqNum.substring(objNumSeqNum.lastIndexOf("_") + 1));
        }
        // this.drawingGroupName = config.CHASSIS_OBJECT_TYPES.VEHICLE;
        // function setDrawingGroupName(group) {
        //     this.drawingGroupName = group;
        //     return this;
        // }
        // this.setDrawingGroupName = setDrawingGroupName;

        if (blockName !== undefined && blockName.indexOf('DASHED') > -1) {
            this.dashEnabled = true;
        } else {
            this.dashEnabled = false;
        }
        
        this.setDashed = function (dashedBool) {
            this.dashEnabled = dashedBool;
        }
        this.setDashLengths = function (dashLength, gapLength) {
            this.dashArray = [dashLength, gapLength];
        }

        this.setLineEndStyle = function (lineEndStyle) {
            this.lineEndStyle = lineEndStyle;
            return this;
        }

        this.setColour = function (colour) {
            this.colour = colour;
        }
        this.bypassHitAreaSort = false;
        this.setBypassHitAreaSort = function (newValue) {
            this.bypassHitAreaSort = newValue;
        }

        this.setDrawingOrder = function (newValue) {
            this.drawingOrder = newValue;
        }

        this.setAlpha = function (newValue) {
            this.alpha = newValue;
            return this;
        }

        // this.setLineWidth = function (newValue) {
        //     this.lineWidth = newValue;
        // }

        // this.setBringToFront = function (newValue) {
        //     this.bringToFront = newValue;
        // }
        }
}

export default Line;


